<template>
	<div class="gb-photoalbum-slideshow" v-bind:style="styleAlbumEdit">
		<Loading v-if="loading" opacity="0.5"/>
		<GBPhotoAlbumHeader 
			v-bind:backURL="backURL" />
		<div class="d-flex">
			<GBPhotoAlbumListAlbumHeader 
				v-bind:name="list_albums.name"
				v-bind:begin="list_albums.begin"
				v-bind:end="list_albums.end"
				v-bind:title="list_albums.title" />
			<div class="gb-header-photo-list" v-bind:style="stylePhotoList">
				<div class="primary gb-header-photo-layout">
					<template>
						<v-layout align-center row fill-height >
							<div style="width:148px;">
								<v-btn flat large color="white" class="pa-0"
									v-bind:disabled="hasParent() == false"
									v-on:click="onClickSlidShowCancel">キャンセル</v-btn>
							</div>
							<v-spacer />
							<nl2br tag="h4" class-name="album-title" :text="headerTitle" />
							<v-spacer />
							<v-btn flat dark color="white" class="pa-0" style="min-width:20px;"
								v-bind:disabled="hasParent() == false"
								v-on:click="onClickDelete">削除</v-btn>
							<v-btn flat dark color="white" class="pa-0"
								v-bind:disabled="hasParent() == false"
								v-on:click="onClickDownload">ダウンロード</v-btn>
						</v-layout>
					</template>
				</div>
			</div>
		</div>
		<div class="d-flex">
			<GBPhotoAlbumSelectList 
				v-bind:items= "listItems"
				v-bind:select_id="photoalbum_id"
				v-on:select-list="selectPhotoAlbum"/>
			<div class="gb-slideshow-content-outer" v-bind:style="styleContentOuter">
				<div class="content">
					<div v-if="hasParent()"
						style="position:relative; height:100%; width: 100%;">
						<v-layout class="align-center" style="height:100%">
							<v-spacer />
							<v-lazy-image
								:key="selectedImageSrc"
								:src="selectedImageSrc"
								:style="styleImage"
							/>
							<v-spacer />
						</v-layout>
						<div v-if="album != null && album.items.length > 1"
							class="btn-navigation btn-navigation-prev" 
							v-on:click="onClickBtnNavigation">
							<v-layout class="align-center" style="height: 100%">
								<v-btn flat
									v-on:click="onClickBtnNavigationPrev" style="height: 100%">
									<v-icon>arrow_left</v-icon>
								</v-btn>
							</v-layout>
						</div>
						<div v-if="album != null && album.items.length > 1"
							class="btn-navigation btn-navigation-next" 
							v-on:click="onClickBtnNavigation">
							<v-layout class="align-center" style="height: 100%">
								<v-btn flat
									v-on:click="onClickBtnNavigationNext" style="height: 100%">
									<v-icon>arrow_right</v-icon>
								</v-btn>
							</v-layout>
						</div>
					</div>
					<DialogConfirmDeletePhotoAlbumItem
						:display="dialog_del.display"
						@click-cancel="onClickCancelDelete"
						@click-confirm="onClickConfirmDelete"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Notification from '../../classes/Notification';
import GBPhotoAlbumListAlbumHeader from './GBPhotoAlbumListAlbumHeader';
import GBPhotoAlbumSelectList from './GBPhotoAlbumSelectList';
import GBPhotoAlbumHeader from './GBPhotoAlbumHeader';
import DialogConfirmDeletePhotoAlbumItem from './DialogConfirmDeletePhotoAlbumItem';
import Loading from '../Loading';
import APIClient from '../../classes/APIClient';
import ConoHa from '../../classes/ConoHa';
import Util from '../../classes/Util'
import VLazyImage from 'v-lazy-image';
import clonedeep from 'lodash/cloneDeep';

const strftime = require('strftime');
const HEADER_HEIGHT = 90;
export default {
	name: 'GBPhotoAlbumSlideShow',
	components: {
		Loading,
		GBPhotoAlbumHeader,
		VLazyImage,
		GBPhotoAlbumSelectList,
		GBPhotoAlbumListAlbumHeader,
		DialogConfirmDeletePhotoAlbumItem,
	},
	props: [
	],
	data: function() {
		return {
			loading: false,
			conoha: null,
			album: null,
			dialog_del: { display: false },
			list_albums: {
				name: null,
				begin: null,
				end: null,
				title: null,
				albums: [],
			},
			api: new APIClient(this.$store),
			photoalbum_id: null,
			project_id: null,
			member_id: null,
			schedule_id: null,
		};
	},
	methods: {
		initData: async function(route) {
			this.loading = true;
			this.photoalbum_id = route.params.photoalbum_id;
			this.list_albums = {
				name: null,
				begin: null,
				end: null,
				title: null,
				albums: [],
			};
			this.dialog_del = { display: false };
			this.project_id = null;
			this.member_id = null;
			this.schedule_id = null;
			this.album = null;
			
			return await this.getPhotoAlbumList().then(() => {
					this.getPhotoAlbum(this.$route.params.photoalbum_id)
						.then(() => {
							this.loading = false;
						});
				}).catch((e) => {
					this.loading = false;
					
					switch (e.response.status) {
					case 404:
						this.error('案件、もしくはスケジュールが削除されました');
						break;
					default:
						this.error('アルバムの取得に失敗しました');
					}
				});
		},
		hasParent: function() {
			return (this.list_albums.name !== null && this.list_albums.albums.length > 0) || (this.album !== null);
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
		prevItem: function() {
			let index = this.indexOfItem() - 1;
			if (index < 0)
				index = this.album.items.length - 1;
			return this.album.items[index];
		},
		nextItem: function() {
			let index = this.indexOfItem() + 1;
			if (this.album.items.length <= index)
				index = 0;
			return this.album.items[index];
		},
		gotoItem: function(id) {
			let uri;
			
			if (this.$route.params.project_id && !this.$route.params.schedule_id) {
				uri = '/' + [
					this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id,
					'album', this.photoalbum_id, 'slideshow',
				].join('/') + '#' + id;
			} else if (this.$route.params.project_id && this.$route.params.schedule_id) {
				uri = '/' + [
					this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id, 'schedule', this.schedule_id,
					'album', this.$route.params.photoalbum_id, 'slideshow',
					].join('/') + '#' + id;
			} else if(this.$route.params.member_id && this.$route.params.schedule_id) {
				uri = '/' + [
					this.$route.params.contractor_id, 'photoalbum', 'member', this.member_id, 'schedule', this.schedule_id,
					'album', this.$route.params.photoalbum_id, 'slideshow',
					].join('/') + '#' + id;
			}
			
			this.$router.push(uri);
		},
		findItem: function() {
			let index = this.indexOfItem();
			if (index < 0)
				return undefined;

			return this.album.items[index];
		},
		memberName() {
			let code = this.$route.params.id;
			let member = this.$store.getters.memberData(code);

			return member ? member.name : '';
		},
		indexOfItem: function() {
			if (!this.album)
				return -1;

			let id = this.$route.hash.replace('#', '');
			return this.album.items.findIndex(item => {
				return item.id == id;
			});
		},
		selectPhotoAlbum: function(id) {
			let uri;
			if(this.$route.params.project_id && !this.$route.params.schedule_id)
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id, 'album'].join('/') + '/#' + id;
			else if(this.$route.params.project_id && this.$route.params.schedule_id)
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id, 'schedule', this.schedule_id, 'album'].join('/') + '/#' + id;
			else if(this.$route.params.member_id && this.$route.params.schedule_id)
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member', this.member_id, 'schedule', this.schedule_id, 'album'].join('/') + '/#' + id;
			
			this.$router.push(uri);
		},
		getPhotoAlbum: async function(id) {
			await this.api.getPhotoAlbum(id).then((res) => {
				let utc = Util.getUTCFromYMDHMS(res.data.last_modified_at);
				this.album = res.data;
				this.album.last_modified = strftime('%Y年%m月%d日', new Date(utc));
				this.api.updateBrowseHistory(this.photoalbum_id);
				this.list_albums.albums.forEach((i) => {
					if(i.id === this.photoalbum_id && !i.reference)
						i.reference = 1;
				});
			}).catch((e) => {
				if (e.token) {
					this.logout();
					return;
				}
				this.error('アルバムが見つかりません。');
			});
		},
		onClickSlidShowCancel: function() {
			let uri;
			if(this.$route.params.project_id && !this.$route.params.schedule_id)
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id, 'album'].join('/') + '/#' + this.photoalbum_id;
			else if(this.$route.params.project_id && this.$route.params.schedule_id)
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id, 'schedule', this.schedule_id, 'album'].join('/') + '/#' + this.photoalbum_id;
			else if(this.$route.params.member_id && this.$route.params.schedule_id)
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member', this.member_id, 'schedule', this.schedule_id, 'album'].join('/') + '/#' + this.photoalbum_id;
			
			this.$router.push(uri);
		},
		onClickBack: function() {
			let uri;
			if (this.is_exist) {
				if(this.$route.params.project_id && !this.$route.params.schedule_id)
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/') + '/#' + this.project_id;
				else if(this.$route.params.project_id && this.$route.params.schedule_id)
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id].join('/') + '/#' + this.schedule_id;
				else if(this.$route.params.member_id && this.$route.params.schedule_id)
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member', this.member_id].join('/') + '/#' + this.schedule_id;
			} else {
				if (this.$route.params.project_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/');
				} else if (this.$route.params.member_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member'].join('/');
				}
			}
			this.$router.push(uri);
		},
		onClickBtnNavigation: function(e) {
			var btn = e.target.getElementsByClassName('v-btn')[0];
			if (btn)
				btn.click();
		},
		onClickBtnNavigationPrev: function() {
			let item = this.prevItem();
			if (item) 
				this.gotoItem(item.id);
		},
		onClickBtnNavigationNext: function() {
			let item = this.nextItem();
			if (item) 
				this.gotoItem(item.id);
		},
		onClickDelete: function() {
			this.dialog_del.display = true;
		},
		onClickCancelDelete: function() {
			this.dialog_del.display = false;
		},
		onClickConfirmDelete: async function() {
			this.dialog_del.display = false;
			this.loading = true;
			let item = this.findItem();
			if (!item)
				return;
			
			let next_index = this.indexOfItem() - 1;
			if (next_index < 0)
				next_index = 1;
			let next_item = this.album.items.length > 1 ? this.album.items[next_index] : null;
			
			try {
				await this.api.deletePhotoAlbumItems(this.photoalbum_id, [item])
					.then(async () => {
						this.deleteFromConoHa([item]);
						if (next_item)
							this.gotoItem(next_item.id);
						else
							this.onClickBack();
					})
					.catch((e) => {
						if (e.token) {
							this.logout();
							return;
						}
						this.error('写真の削除に失敗しました');
					});
			} finally {
				this.loading = false;
			}
		},
		deleteFromConoHa: function(items) {
			return Util.chunkSplitPromiseAll(items, async (item) => {
				/* サムネイルは残す */
				// await this.conoha.deleteByURI(item.thumbnail_uri);
				await this.conoha.deleteByURI(item.photo_uri);
			});
		},
		onClickDownload: function() {
			let item = this.findItem();
			if (item) {
				let a = document.createElement('a');
				a.setAttribute('href', item.photo_uri);
				a.setAttribute('download', '');
				document.body.appendChild(a);
				try {
					a.click();
				} finally {
					document.body.removeChild(a);
				}
			}
		},
		getPhotoAlbumList: async function() {
			if(this.$route.params.project_id && !this.$route.params.schedule_id) {
				this.project_id = this.$route.params.project_id;
				await this.api.getPhotoAlbumListOfProject(this.project_id).then((res) => {
						this.list_albums.albums = res.data.album_list;
						this.list_albums.name = res.data.project.name;
					}).catch((e) => {
						if (e.token) {
							this.logout();
							return;
						}
						
						throw e;
					});
			} else if (this.$route.params.schedule_id) {
				this.schedule_id = this.$route.params.schedule_id;
				await this.api.getPhotoAlbumListOfSchedule(this.schedule_id).then((res) => {
						this.list_albums.albums = res.data.album_list;
						if (this.$route.params.project_id)
							this.list_albums.name = res.data.member.name;
						else if (this.$route.params.member_id)
							this.list_albums.name = res.data.project.name;
						this.list_albums.begin = res.data.schedule.begin;
						this.list_albums.end = res.data.schedule.end;
						this.list_albums.title = res.data.schedule.title;
						
						this.project_id = res.data.project.id;
						this.member_id = res.data.member.id;
					}).catch((e) => {
						if (e.token) {
							this.logout();
							return;
						}
						throw e;
					});
			}
		},
		error: function(text) {
			this.$store.dispatch('addNotification', Notification.error(text));
		},
		logout: function() {
			this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
	},
	computed: {
		backURL: function() {
			let uri;
			if (this.hasParent()) {
				if(this.$route.params.project_id && !this.$route.params.schedule_id)
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/') + '/#' + this.project_id;
				else if(this.$route.params.project_id && this.$route.params.schedule_id)
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id].join('/') + '/#' + this.schedule_id;
				else if(this.$route.params.member_id && this.$route.params.schedule_id)
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member', this.member_id].join('/') + '/#' + this.schedule_id;
			} else {
				if (this.$route.params.project_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/');
				} else if (this.$route.params.member_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member'].join('/');
				}
			}
			return uri;
		},
		stylePhotoList: function() {
			let left = this.$store.getters.boardLeftPosition;
			let width = this.$store.getters.width - 300;
			
			return {
				width: width + 'px',
				left: left + 'px',
			};
		},
		styleImage: function() {
			let width = this.$store.getters.width - 300;
			let height = this.$store.getters.height - 90;
			return {
				'max-width': width + 'px',
				'max-height': height + 'px',
			};
		},
		styleContentOuter: function() {
			return {
				height: (this.$store.getters.height - HEADER_HEIGHT) + 'px',
			};
		},
		styleAlbumEdit: function() {
			let left = this.$store.getters.boardLeftPosition;
			let width = this.$store.getters.width - left;
			
			return {
				width: width + 'px',
				left: left + 'px',
			};
		},
		headerTitle() {
			if (this.album == null)
				return '';

			let index = this.indexOfItem();
			if (index < 0)
				return '';
			let item = this.album.items[index];
			return this.album.title.substring(0, 15) +
				'(' + (index + 1) + '/' + this.album.items.length + ')' +
				"\n" +
				item.insert_member_name;
		},
		selectedImageSrc: function() {
			if (!this.album)
				return '';

			let item = this.findItem();
			if (!item) {
				this.error('写真がありません');
				return '';
			}

			return item.photo_uri;
		},
		listItems: function() {
			return clonedeep(this.list_albums.albums).map(item => {
				return {
					'id': item.id,
					'name': item.title,
					'reference': item.reference,
				};
			});
		},
	},
	mounted(){
		this.conoha = new ConoHa(this.$store.getters.datasetManager);
		this.initData(this.$route);
	},
	created: function() {
		window.addEventListener('resize', this.onWindowResize, false);
		this.onWindowResize();
	},
	beforeRouteUpdate(to, from, next) {
		this.initData(to)
			.then(() => {
				next();
			});
	},
	beforeDestroy: function() {
		window.removeEventListener('resize', this.onWindowResize);
	},
};
</script>
<style>
	.gb-photoalbum-slideshow {
		height: 100%;
		background-color: black;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}
	.gb-photoalbum-slideshow .btn-navigation {
		position: absolute;
		top: 0;
		height: 100%;
		width: 6em;
		cursor: pointer;
	}
	.gb-photoalbum-slideshow .gb-slideshow-content-outer {
		overflow-y: hidden;
		overflow-x: hidden;
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	.gb-photoalbum-slideshow .gb-slideshow-content-outer .content {
		width: 100%;
		height: 100%;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior-y: contain;
	}
	.gb-photoalbum-slideshow .btn-navigation:hover {
		background-color: white;
		opacity: .3;
	}
	.gb-photoalbum-slideshow .gb-header-photo-list {
		position: relative;
		border:solid 1px #DFDFDF;
		height: 59px;
		border-left: none;
	}
	.gb-photoalbum-slideshow .gb-header-photo-layout {
		position: relative;
		padding: 0px 19px 0px 0px;
		height: 57px;
	}
	.gb-photoalbum-slideshow .btn-navigation .v-btn {
		padding: 0;
		margin: 0;
	}

	.gb-photoalbum-slideshow .btn-navigation .v-icon {
		font-size: 88px;
		display: none;
	}

	.gb-photoalbum-slideshow .btn-navigation:hover .v-icon {
		color: black;
		display: inline;
	}

	.gb-photoalbum-slideshow .btn-navigation-perv {
		left: 0;
	}

	.gb-photoalbum-slideshow .btn-navigation-next {
		right: 0;
	}
	.gb-photoalbum-slideshow .album-title {
		color: white;
		text-align: center;
	}
</style>
